import { render, staticRenderFns } from "./ViewConfig.vue?vue&type=template&id=b1fec480&scoped=true&"
import script from "./ViewConfig.vue?vue&type=script&lang=js&"
export * from "./ViewConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fec480",
  null
  
)

export default component.exports